module.exports = __webpack_public_path__ + "static/img/pizza.f7bfe64.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pizza.gif
// module id = NYcK
// module chunks = 4